<p-inputNumber [disabled]="
    loading || (searchResult && !searchResult.inStock) || stockLevel == 0
  " class="custom-increment-decrement-input {{ classess }}" [style.max-width.px]="maxWidth" [max]="stockLevel"
  [class.small-buttons]="smallButtons" [class.light]="darkMode" [class.error]="stockLevel < quantity" [step]="1"
  [allowEmpty]="false" [mode]="'decimal'" [min]="min ? min : !orderLine && 1" [(ngModel)]="quantity"
  (ngModelChange)="quantityObservable.next($event)" [showButtons]="true" buttonLayout="horizontal"
  decrementButtonClass="custom-input-decrement-btn" incrementButtonClass="custom-input-increment-btn"
  incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus">
</p-inputNumber>
